import { useState } from "react";
import logoIcon from "../assets/logo-icon.png";
import type { Page } from "../types";

export function Navbar({ onNavigate }: { onNavigate: (p: Page) => void }) {
    const [open, setOpen] = useState(false);

    const goHome = () => { onNavigate("home"); setOpen(false); };
    const goContact = () => { onNavigate("contact"); setOpen(false); };

    const links = [
        { action: () => { goHome(); setTimeout(() => document.getElementById("atouts")?.scrollIntoView({ behavior: "smooth" }), 100); }, label: "Nos atouts" },
        { action: () => { goHome(); setTimeout(() => document.getElementById("services")?.scrollIntoView({ behavior: "smooth" }), 100); }, label: "Services" },
        { action: () => { goHome(); setTimeout(() => document.getElementById("produits")?.scrollIntoView({ behavior: "smooth" }), 100); }, label: "Nos produits" },
        { action: () => { goHome(); setTimeout(() => document.getElementById("methode")?.scrollIntoView({ behavior: "smooth" }), 100); }, label: "Méthode" },
        { action: goContact, label: "Contact" },
    ];

    return (
        <>
            <nav className="fixed top-0 w-full z-50 bg-white/90 backdrop-blur border-b border-slate-200">
                <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
                    <button onClick={goHome} className="flex items-center gap-2 cursor-pointer">
                        <img src={logoIcon} alt="appitep" className="h-9" />
                        <span className="text-xl font-bold tracking-tight text-[#1a3660]">
                            APPI<span className="text-[#f07020]">TEP</span>
                        </span>
                    </button>

                    {/* Desktop links */}
                    <div className="hidden md:flex items-center gap-8">
                        {links.map((l) => (
                            <button
                                key={l.label}
                                onClick={l.action}
                                className="text-sm text-slate-600 hover:text-[#f07020] transition-colors cursor-pointer"
                            >
                                {l.label}
                            </button>
                        ))}
                        <button
                            onClick={goContact}
                            className="text-sm font-semibold bg-[#f07020] hover:bg-[#d9621a] text-white px-4 py-2 rounded-lg transition-colors cursor-pointer"
                        >
                            Parlons de votre projet
                        </button>
                    </div>

                    {/* Mobile burger */}
                    <button
                        onClick={() => setOpen(!open)}
                        className="md:hidden text-slate-600 hover:text-[#f07020]"
                        aria-label="Menu"
                    >
                        <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                        </svg>
                    </button>
                </div>
            </nav>

            {/* Mobile drawer backdrop */}
            <div
                className={`fixed inset-0 z-[60] md:hidden transition-opacity duration-300 ${open ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"}`}
                onClick={() => setOpen(false)}
            >
                <div className="absolute inset-0 bg-black/40" />
            </div>
            {/* Mobile drawer panel */}
            <div
                className={`fixed top-0 right-0 z-[70] h-full w-72 bg-white shadow-xl md:hidden transition-transform duration-300 ease-in-out ${open ? "translate-x-0" : "translate-x-full"}`}
            >
                <div className="flex items-center justify-between px-6 h-16 border-b border-slate-200">
                    <span className="text-lg font-bold text-[#1a3660]">Menu</span>
                    <button onClick={() => setOpen(false)} className="text-slate-500 hover:text-[#f07020]" aria-label="Fermer">
                        <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>
                <div className="flex flex-col px-6 py-4 gap-1">
                    {links.map((l) => (
                        <button
                            key={l.label}
                            onClick={l.action}
                            className="block w-full text-left py-3 text-slate-600 hover:text-[#f07020] transition-colors cursor-pointer border-b border-slate-100"
                        >
                            {l.label}
                        </button>
                    ))}
                    <button
                        onClick={goContact}
                        className="block w-full mt-4 text-center font-semibold bg-[#f07020] hover:bg-[#d9621a] text-white px-4 py-2.5 rounded-lg transition-colors cursor-pointer"
                    >
                        Parlons de votre projet
                    </button>
                </div>
            </div>
        </>
    );
}
